import Vue from 'vue'
import App from './App'
import VueI18n from 'vue-i18n'
import Vuelidate from 'vuelidate'
import Vuex from 'vuex'
import Buefy from 'buefy'
import IdleVue from 'idle-vue'
import { datadogRum as datadog } from '@datadog/browser-rum'

import { translations as messages } from './translations'
import router from '@/router'
import store from '@/store'
import config from '../config'
import { loadRuntimeConfig } from '@/services/runtimeConfig'

import '@mdi/font/css/materialdesignicons.css'
import 'vue-material-design-icons/styles.css'

const eventsHub = new Vue()

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueI18n)
Vue.use(Vuex)
Vue.use(Buefy, {
  defaultIconPack: 'mdi'
})
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 300000
})

Vue.filter('upperCase', text => text.toUpperCase())
Vue.filter('stripHour', date => date.split(' ').slice(0, 1).join(' '))

Vue.prototype.$eventBus = new Vue()

const i18n = new VueI18n({
  locale: 'pt_PT', // ! for more locales, please add on translations file
  fallbackLocale: 'pt_PT',
  messages
})

async function bootstrap () {
  await loadRuntimeConfig()

  if (config.datadog.isEnabled) {
    datadog.init(config.datadog.config)

    if (config.datadog.enableSessions) datadog.startSessionReplayRecording()
  }

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    i18n,
    store,
    components: { App },
    template: '<App/>'
  })
}

bootstrap()



// WEBPACK FOOTER //
// ./src/main.js